export const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
    {...props}
  >
    <path
      stroke="#7D8291"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M11.962 5.707a3.98 3.98 0 1 1-5.629 5.63 3.98 3.98 0 0 1 5.63-5.63M11.934 11.36l3.9 3.953"
    ></path>
  </svg>
);
